(function($) {

    formHelper.addRule({
        form: '.form-manage-resort-highlights-banner',
        status: {
            SUCCESS: function() {

                this.redirect(this.data.redirectTo);
            },
            ERROR: function() {

                if (this.data.systemMessage1 !== undefined) {

                    $('#system-message-1').html(this.data.systemMessage1);
                }

                if (this.data.systemMessage2 !== undefined) {

                    $('#system-message-2').html(this.data.systemMessage2);
                }
            }
        }
    });

})(jQuery);

